import { render, staticRenderFns } from "./edit-recommendation.vue?vue&type=template&id=1d03f7e0&"
import script from "./edit-recommendation.vue?vue&type=script&lang=js&"
export * from "./edit-recommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports